import script from "./LessonMaterialsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonMaterialsPage.vue?vue&type=script&setup=true&lang=js"

import "./LessonMaterialsPage.vue?vue&type=style&index=0&id=4d817392&scoped=true&lang=css"
import "./LessonMaterialsPage.vue?vue&type=style&index=1&id=4d817392&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d817392"]])

export default __exports__